import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, Clock, MapPin, PlaneTakeoff } from "lucide-react";
import { usePlatform } from "@/hooks/usePlatform";

const perks = [
  { icon: Bell, label: "Alerts when your line spikes" },
  { icon: PlaneTakeoff, label: "Gate-change push notifications" },
  { icon: Clock, label: "Personal leave-by timer" },
  { icon: MapPin, label: "Saved airports & quick switch" },
];

export const ProUpsellStrip = () => {
  const { isNative } = usePlatform();
  if (isNative) return null;

  return (
    <Card className="rounded-xl shadow-md">
      <CardContent className="py-6 space-y-4">
        <div>
          <h2 className="text-xl font-bold text-foreground">
            Wait times are always free. Pro watches the airport for you.
          </h2>
          <p className="text-base text-muted-foreground mt-1">
            Upgrade in the app to get told when to leave instead of checking.
          </p>
        </div>
        <ul className="grid sm:grid-cols-2 gap-3">
          {perks.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-center gap-2 text-base text-muted-foreground">
              <Icon className="h-5 w-5 text-primary shrink-0" aria-hidden="true" />
              {label}
            </li>
          ))}
        </ul>
        <Button asChild variant="outline" className="min-h-[44px] rounded-xl active:scale-95">
          <Link to="/pricing">See Pro plans</Link>
        </Button>
      </CardContent>
    </Card>
  );
};
